import { WidgetSize } from '@wix/wix-chatbot-common/browser';

import type { TRootState } from '../reducers';

export const selectWidgetSize = ({ widget }: TRootState): WidgetSize => widget.size;
export const selectWidgetExpanded = ({ widget }: TRootState): boolean => widget.expanded;
// TODO: remove after adding mobile app
export const selectWidgetMobileView = ({ widget }: TRootState): boolean | undefined => widget.mobileView;
export const selectCaraFullPageSessionActive = ({ widget }: TRootState): boolean =>
  widget.caraFullPageSessionActive;
export const selectCaraSurveyPending = ({ widget }: TRootState): boolean => widget.caraSurveyPending;
